import { z } from 'zod';
import { PersonRef } from './people.js';
import { Priority, WorkItemType } from './work-items.js';
/**
 * Read-only share links for a task or ticket, for people outside the workspace
 * (docs/BRIEF_CHANGE_PROPOSALS.md 1.5, approved). Controls: workspace switch, who can create,
 * mandatory expiry, revoke, view count, audit on create, view and revoke. Internal fields never leave.
 */
export const ShareLink = z.object({
    id: z.uuid(),
    workItemId: z.uuid(),
    workItemKey: z.string(),
    workItemTitle: z.string(),
    createdBy: PersonRef.nullable(),
    createdAt: z.string(),
    expiresAt: z.string(),
    revokedAt: z.string().nullable(),
    viewCount: z.number().int(),
    lastViewedAt: z.string().nullable(),
    /** The address the link was emailed to, when it was shared with one (docs/adr/0089). */
    sharedWithEmail: z.string().nullable(),
});
export const CreatedShareLink = ShareLink.extend({
    /** Shown once. Only a hash is stored. */
    url: z.string(),
});
export const CreateShareLinkInput = z.object({
    expiresInDays: z.number().int().min(1).max(365).optional(),
    /** Email the link to this address. They need no account; the page offers sign-up and sign-in (docs/adr/0089). */
    email: z.email().max(254).optional(),
});
export const ShareLinkList = z.object({ items: z.array(ShareLink) });
export const SharedWorkItem = z.object({
    workspaceName: z.string(),
    key: z.string(),
    type: WorkItemType,
    title: z.string(),
    description: z.string(),
    statusLabel: z.string(),
    statusColor: z.enum(['slate', 'blue', 'violet', 'red', 'green', 'orange']),
    priority: Priority,
    dueDate: z.string().nullable(),
    projectName: z.string(),
    subtasks: z.array(z.object({ title: z.string(), done: z.boolean() })),
    updatedAt: z.string(),
    expiresAt: z.string(),
});
/**
 * The issue (`path: 'link'`) on the public view's 404 when the link's creator is no longer a member of the
 * workspace, so the page can say why instead of "expired". Every other 404 (expired, revoked, sharing or the
 * item's feature switched off) carries no issue.
 */
export const SHARE_LINK_CREATOR_LEFT = 'creator_left';
//# sourceMappingURL=sharing.js.map